import React from 'react'
import url from 'libraries/front-end-core/core/url'
import { SEARCH } from 'constants/controllers'
import { ALL_FLAVOURS, DEFAULT_FLAVOUR, FLAVOUR_TITLES } from 'constants/flavours'
import FlavourSelector from 'components/shared/FlavourSelector'
import FlavourIcon from 'components/shared/FlavourIcon'

export const QAHeader = ({ aol, flavour = DEFAULT_FLAVOUR, searchType, searchPhrase, query }) => {
  return (
    <div className='bg-page-background w-100'>
      <div className='layout-width-constraint pt6 pb3 flex justify-between items-start'>
        <span className='fht fw6'>Q&A Search results</span>
        <span className='flex flex-wrap justify-end gap7'>
          <div className='flex gap7'>
            <FlavourSelector
              options={
                ALL_FLAVOURS.map(flavour => ({
                  label: (
                    <div className='flex items-center gap5'>
                      <FlavourIcon flavour={flavour} bw />
                      {FLAVOUR_TITLES[flavour]}
                    </div>
                  ),
                  href: url(SEARCH, { aol, flavour, searchType }, query)
                }))
              }
            />
          </div>
        </span>
      </div>
    </div>
  )
}
